module.exports = __webpack_public_path__ + "img/bg-auth.8d71c9dd.png";